import Work1 from "../../assets/work/work1.jpg"
import Work2 from "../../assets/work/work2.jpg"
import Work3 from "../../assets/work/work3.jpg"
import Work4 from "../../assets/work/work4.jpg"
import Work5 from "../../assets/work/work5.jpg"
import Work6 from "../../assets/work/work6.jpg"
import Work7 from "../../assets/work/work7.jpg"
import Work8 from "../../assets/work/work8.jpg"
import Work9 from "../../assets/work/work9.jpg"
import Work10 from "../../assets/work/work10.jpg"
import Work11 from "../../assets/work/work11.jpg"
import Work12 from "../../assets/work/work12.jpg"
import Work13 from "../../assets/work/work13.jpg"
import Work14 from "../../assets/work/work14.jpg"


const Menu = [
  {
    id: 1,
    image: Work13,
    title: "KR11",
    category: "UI Design",
    demo: ""
  },
  {
      id: 2,
      image: Work14,
      title: "UMBA",
      category: "UI Design",
      demo: ""
    },
    {
      id: 3,
      image: Work1,
      title: "Home DigiLand",
      category: "UI Design",
      demo: "https://www.instagram.com/p/CkbFlRAjfQ4/"
    },
    {
      id: 4,  
      image: Work6,
      title: "Recharge Market",
      category: "UI Design",
      demo: "https://www.instagram.com/p/Cj6RER3jhtd/"
    },
    {
      id: 5,
      image: Work9,
      title: "Dr. Priyanaka Yaduvanshi",
      category: "Mobile App",
      demo: "https://play.google.com/store/apps/details?id=com.jmm.doctor_consultation"
    },
    {
      id: 6,
      image: Work5,
      title: "Sampurna Daily Audit",
      category: "Website",
      demo: "https://dailyaudit.pocketmoney.net.in/"
    },
    {
      id: 7,
      image: Work3,
      title: "Doctor Consult API ",
      category: "API",
      demo: ""
    },  
    {
      id: 8,
      image: Work8,
      title: "Doctor Setu",
      category: "UI Design",
      demo: "https://www.instagram.com/p/Cj6RMM0jBQ0/"
    },  
    {
      id: 9,
      image: Work2,
      title: "Institute Management API",
      category: "API",
      demo: ""
    },
    {
      id: 10,
      image: Work4,
      title: "Zoya Fabricator",
      category: "Website",
      demo: "https://uat.zoyafabricators.com/"
    },
    {
      id: 11,
      image: Work7,
      title: "RK Classes",
      category: "UI Design",
      demo: "https://www.instagram.com/p/Cj8U5Lfj0Er/"
    },
    {
      id: 12,
      image: Work10,
      title: "Weather Setu",
      category: "Website",
      demo: "https://pavan-weather-setu.netlify.app/"
    },
    {
      id: 13,
      image: Work11,
      title: "Election Setu",
      category: "DApps App",
      demo: "#"
    },
    {
      id: 14,
      image: Work12,
      title: "Simple Home Automation",
      category: "IoT",
      demo: "#"
    },
  ];
  

export default Menu